export default __webpack_public_path__ + "static/media/JOLT-BNB.ec9d2fb8.svg";